import { ActivatedRoute } from '@angular/router';
import { CommonService } from './../../../services/common.service';
import { UserService } from './../../../services/user.service';
import { StoreService } from 'src/app/services/store.service';
import { CommonMessageService } from './../../../services/common-message.service';
import { ModalController, NavController } from '@ionic/angular';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  changePassWordForm: FormGroup;
  passwordControl: AbstractControl;
  constructor(
    private fb: FormBuilder,
    private modalController: ModalController,
    private commonMessager: CommonMessageService,
    private store: StoreService,
    private userService: UserService,
    private common: CommonService,
    private navCtr: NavController
  ) { }

  ngOnInit() {
    this.buildChangePasswordForm();
  }

  async changePassWord() {
    const loading = await this.commonMessager.loading('Patientez un instant');
    try {
      const credential = {
        login: this.userService.currentUser.loginEmail,
        newPassword: this.changePassWordForm.value.newPassword,
        oldPassword: this.changePassWordForm.value.oldPassword
      };
      const data = (await this.userService.changePassword(credential).toPromise()) as any;
      if (data.message === 'OK') {
        await this.commonMessager.successToast('Mot de passe modifié avec succes.');
      } else {
        await this.commonMessager.successToast('Echec lors de la modification du mot de passe.');
      }
      this.navCtr.navigateRoot('/dash');
    } catch (error) {
      this.commonMessager.errorToast('Erreur:  ' + error);
    } finally {
      loading.dismiss();
    }
  }

  private buildChangePasswordForm() {
    this.changePassWordForm = this.fb.group({
      'oldPassword': ['', [Validators.required]],
      'newPassword': ['', [
        Validators.required,
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)
      ]],
      'confirmePassword': ['', [Validators.required]],
    },
      {
        validator: (group) => {
          return group.get('newPassword').value === group.get('confirmePassword').value ? null : { notSame: true };
        }
      });
      this.passwordControl = this.changePassWordForm.get('password');
  }

  close(data?) {
    this.modalController.dismiss(data);
  }
}
